import type { Address } from 'types/Project';
import axios from '../axiosClient';

type PaymentPayload = {
  amount: number | string;
  type: string;
  success_url: string;
  cancel_url: string;
  id_project: number;
  payment_method: string[];
  from_company: boolean;
  siren: string;
  company_name: string;
  addressCompany: Address;
  address: Address;
}

export const createPayment = (value: PaymentPayload) => axios.post('/make-payment', value);
